module.exports = __webpack_public_path__ + "img/CaretUp.2099cfe6.svg";